import { Outlet } from "react-router-dom";

const SiteEquipmentManagementPageLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default SiteEquipmentManagementPageLayout;
